import { Box, Collapse, Stack } from "@mui/material";
import React, { useState } from "react";
import Template from "models/template";
import MetadataModelTemplate from "./metadata-model-template";
import CollapseButton from "components/common/render-field/collapse-button";

function MetadataModelTemplates({
  input_id,
  templates,
}: {
  input_id: string;
  templates: Template[];
}) {
  const [collapse, setCollapse] = useState(false);
  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <CollapseButton
        label="Export metadata"
        isOpen={collapse}
        HandleCollapse={setCollapse}
      />
      <Collapse in={collapse} sx={{ width: "100%" }}>
        <Stack px={2}>
          {templates.map((template) => (
            <MetadataModelTemplate
              input_id={input_id}
              template={template}
              key={template.guid}
            />
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
}

export default MetadataModelTemplates;
